import React from "react";

import { useTypedParams } from "react-router-typesafe-routes/dom";
import { ROUTES } from "src/routes";

import { PastResaleReports } from "@pages/dashboard/PastResaleReports";

const PastResaleReportsComponent = () => {
  const { participantId } = useTypedParams(ROUTES.Profile.AccountDetails);

  return (
    <div className="pt-5">
      <h4>Past Resale Reports</h4>
      <PastResaleReports displayBanner={false} vendorId={participantId} />
    </div>
  );
};

export default PastResaleReportsComponent;
